import { render } from "./DownloadComp.vue?vue&type=template&id=6a7344db&scoped=true&ts=true"
import script from "./DownloadComp.vue?vue&type=script&lang=ts"
export * from "./DownloadComp.vue?vue&type=script&lang=ts"

import "./DownloadComp.vue?vue&type=style&index=0&id=6a7344db&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7344db"]])

export default __exports__